import { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useQuizLoginMutation } from '../../slices/fun_stuff/quizUsersSlice';
import { setQuizCredentials } from '../../slices/fun_stuff/quizAuthSlice';
import { useLoadQuizChallenges } from '../../hooks/useLoadQuizChallenges';
import { useLoadQuizList } from '../../hooks/useLoadQuizList';
import { useLoadQuizScoreboard } from '../../hooks/useLoadQuizScoreboard';
import { useLoadQuizGroups } from '../../hooks/useLoadQuizGroups';
import { useLoadQuestionFeedback } from '../../hooks/useLoadQuestionFeedback';
import { useLoadGeneralFeedback } from '../../hooks/useLoadGeneralFeedback';
import Loader from '../../components/Loader';
import { toast } from 'react-toastify';

const QuizLogin = ({ setShow }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const dispatch = useDispatch();

  const [ login, { isLoading }] = useQuizLoginMutation();

  const { loadGroups } = useLoadQuizGroups();
  const { loadScoreboard } = useLoadQuizScoreboard();
  const { loadChallenges } = useLoadQuizChallenges();
  const { loadQuizzes } = useLoadQuizList();
  const { loadQuestionFeedback } = useLoadQuestionFeedback();
  const { loadGeneralFeedback } = useLoadGeneralFeedback();

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      const res = await login({ username, password }).unwrap();
      dispatch(setQuizCredentials({...res}));

      await Promise.all([
        loadGroups(),
        loadChallenges(),
        loadScoreboard(),
        loadQuizzes(),
      ]);
      if (res.is_admin) { 
        await loadQuestionFeedback();
        await loadGeneralFeedback();
      }

      setShow(false);
      setUsername('');
      setPassword('');
    } catch (error) {
      toast.error(error?.data?.message || error.error);
    }
  }

  return (
    <div>
      <h2 className='mt-3'>Login</h2>

      <Form onSubmit={submitHandler}>
        <Form.Group controlId='username' className='my-1' style={{ maxWidth: '250px' }}>
          <Form.Label>Username</Form.Label>
          <Form.Control 
            type='text'
            placeholder='Enter username'
            value={username}
            onChange={(e) => setUsername(e.target.value)}>
            </Form.Control>
        </Form.Group>

        <Form.Group controlId='password' className='my-1 mw-300' style={{ maxWidth: '250px' }}>
          <Form.Label>Password</Form.Label>
          <Form.Control 
            type='password'
            placeholder='Enter password'
            value={password}
            onChange={(e) => setPassword(e.target.value)}>
            </Form.Control>
        </Form.Group>

        <Button type='submit' className='quiz-btn-dark mt-2' disabled={isLoading}>
          Sign In
        </Button>
        { isLoading && <Loader />}
      </Form>
    </div>
  )
}

export default QuizLogin
